import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export const fetchManufacturers = () => axios.get('/vehicle-manufacturers');
export const fetchStatuses = () => axios.get('/vehicle-statuses');
export const fetchTypes = () => axios.get('/vehicle-types');
export const fetchDisabledAccesses = () => axios.get('/disabled-accesses');
export const fetchRightTypes = () => axios.get('/right-types');
export const fetchOrganizationalUnits = () => axios.get('/organizational-units');
export const fetchMunicipalities = () => axios.get('/municipalities');
export const fetchCantons = () => axios.get('/cantons');
export const fetchEntities = () => axios.get('/entities');
export const fetchCountries = () => axios.get('/countries');
export const fetchRoomTypes = () => axios.get('/room-types');
export const fetchEquipmentTypes = () => axios.get('/equipment-types');
export const fetchEquipmentTypesByOrganizationalUnitId = (organizationalUnitId) => axios.get(`/equipment-types/by-organizational-unit/${organizationalUnitId}`);
export const fetchOrgUnitPropertiesByOrganizationalUnitId = (organizationalUnitId) => axios.get(`/assets/organizational-unit-properties/by-organizational-unit/${organizationalUnitId}/`);
export const fetchPropertiesByOrganizationalUnitId = () => axios.get('/assets/properties/by-organizational-unit/');
export const fetchUnitTypes = () => axios.get('/unit-types');
export const fetchFuelType = () => axios.get('/fuel-types');
export const fetchEntityTypes = () => axios.get('/entity-types');
export const fetchContactTypes = () => axios.get('/contact-types');
export const fetchLegalDocumentTypes = () => axios.get('/legal-document-types');

export const fetchOrganizationalUnitProperties = () => axios.get('/assets/organizational-unit-properties/all');
export const fetchLeaseholders = () => axios.get('/assets/leaseholders/all');

// TODO: Mapping required to do here, move util.js to util folder, you are not interested if it is lookup or not



// WEBPACK FOOTER //
// ./src/views/Assets/Lookups/util.js